import { render, staticRenderFns } from "./TemplateDetailsPageHeader.vue?vue&type=template&id=53673279&scoped=true"
import script from "./TemplateDetailsPageHeader.vue?vue&type=script&lang=js"
export * from "./TemplateDetailsPageHeader.vue?vue&type=script&lang=js"
import style0 from "@/modules/Templates/assets/css/template-detail-header.css?vue&type=style&index=0&id=53673279&prod&scoped=true&lang=css&external"
import style1 from "./TemplateDetailsPageHeader.vue?vue&type=style&index=1&id=53673279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53673279",
  null
  
)

export default component.exports